import React, { Suspense } from "react";
import { lazyWithRetry } from "../utils/lazyWithRetry";

const ProductFinderDebugRoute = lazyWithRetry(() =>
  import("./ProductFinderDebugRoute").then((m) => ({
    default: m.ProductFinderDebugRoute,
  })),
);

const LoadingFallback = () => <div style={{ width: "100%", height: "100%" }} />;

export const ProductFinderDebugRouteLazy = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <ProductFinderDebugRoute {...props} />
  </Suspense>
);
